import audio from '../../../../assets/audio/kids-tracks/Text17.mp3';

export const step23road = {
    id: 23,
    title: 'Pokračujeme',
    taskText: `
        <p>
            Tak máme jít dál po cestě. U dalšího mostku čeká jeho bratr. Jo a moc děkuje za vysvobození.
        </p>
    `,
    continueButtonText: 'Jsme u 2. mostu',
    points: false,
    audio: audio,
};
